import { render, staticRenderFns } from "./cocktail-tall-6.vue?vue&type=template&id=f8003f96"
import script from "./cocktail-tall-6.vue?vue&type=script&lang=js"
export * from "./cocktail-tall-6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports